/*
 * @Author: zgz
 * @Date: 2021-01-20 20:42:19
 * @LastEditors: zgz
 * @LastEditTime: 2021-01-22 16:13:59
 * @Description: 
 */
import Axios from "axios";
import promise from "es6-promise";

// 兼容 Promise
promise.polyfill();

Axios.interceptors.response.use();

function request(type, url, params) {
  var DOMAIN = window.DOMIN;
  // console.log('DOMAIN --:> ' + JSON.stringify(DOMAIN))
  let time = parseInt(new Date().getTime() / 1000); // 秒级时间戳
  params["ad_position_id"] = "10023372";
  params["package_id"] = "23305";
  params["event_time"] = time;
  return new Promise((resolve, reject) => {
    var promise;
    if (type === "get") {
      promise = Axios.get(DOMAIN + url, {
        params,
      });
    } else {
      promise = Axios.post(DOMAIN + url, {
        params,
      });
    }
    promise
      .then((response) => {
        var result = JSON.stringify(response);
        resolve(result);
      })
      .catch((err) => {
        reject(err.response.data)
        // var msg = err.response.data.msg
        // console.log(msg);
      });
  });
}

export default request;


// WEBPACK FOOTER //
// ./src/components/common/axios/axios.js